import {inject, injectable} from "inversify";
import type {Component, Ref, ShallowRef} from "vue";
import {ActionInterface} from "@/modules/action-screens/interfaces";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";

type ControlsType = {
  visible: Ref<boolean>,
  component: ShallowRef<Component | undefined>,
  props: Ref<{ [key: string]: any } | undefined>,
  close: () => void,
};

@injectable()
export default class ActionScreener implements ControlsType {
  resolve?: (value?: unknown) => void;

  constructor(
    @inject(ConfigRepository) public configRepository: ConfigRepository,
    public visible: Ref<boolean> = ref(false),
    public component: ShallowRef<Component | undefined> = ref(),
    public props: Ref<{ [key: string]: any } | undefined> = ref(),
  ) {}

  async show(action: ActionInterface) {
    console.debug('show action screen', action);

    this.component.value = action.component;
    this.props.value = action.props;
    this.visible.value = true;

    return new Promise((resolve) => this.resolve = resolve);
  }

  async close() {
    if (!this.resolve) {
      throw 'Need to open action screen before closing it.';
    }

    setTimeout(this.resolve, this.configRepository.get('ui.actionScreens.minTimeBetweenActionScreens') as number);

    this.resolve = undefined;
    this.component.value = undefined;
    this.props.value = undefined;
    this.visible.value = false;
  }
}
